import { pillarName } from '../lib/pillars'

// Which pillar of the strategy a measurement files under (DEC-2026-09-23-01): one chip beside the number,
// so what is on the screen can be lifted into the board deck under the pillar it proves.
export function PillarChip({ pillar }: { pillar: string | null | undefined }) {
  const name = pillarName(pillar)
  if (!name) return null
  return <span className="chip pillar-chip" title="The strategy pillar this measurement files under">{name}</span>
}
